export default __webpack_public_path__ + "static/media/image-validation.b2841c6a.png";